import { authInstance, dfdInstance, forfaitInstance,crcInstance } from "../../Axios";

export const searchDemandesApi = (payload) => {
  return dfdInstance
    .post(
      `/api/demandes/search?modeConsultation=${payload.searchObject.modeConsultation}&&page=${payload.searchObject.pagination.page}&&size=${payload.searchObject.pagination.pageSize}`,
      payload.searchObject.demandFDDto
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getCategorieApi = () => {
  return dfdInstance
    .get(`/api/demandes/typeDfd`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getEtatsApi = () => {
  return dfdInstance
    .get(`/api/demandes/state`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getGroupesContingentApi = () => {
  return dfdInstance
    .get(`/api/categorie`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getPaysOrigineApi = () => {
  return dfdInstance
    .get(`/api/pays/getAlloriginCountry`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getNomenclaturesApi = (payload) => {
  return dfdInstance
    .post(
      `api/nomenclature?page=${payload.payload.nomenclaturePagination.page}&&size=${payload.payload.nomenclaturePagination.pageSize}`,
      payload.payload.nomenclatureDTO
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getImportateursApi = (payload) => {
  return dfdInstance
    .post(`importateurs`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getDfdByIdApi = (payload) => {
  return dfdInstance
    .get(`api/demandes/findDfd?id=${payload.id}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getDfdDecisionsApi = (payload) => {
  return dfdInstance
    .get(`api/demandes/findDecisionsList?id=${payload.id}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getDfdDocumentsApi = (payload) => {
  return dfdInstance
    .get(`documents/getByDFD?idDemande=${payload.id}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getDfdMarchandisesApi = (payload) => {
  return dfdInstance
    .get(`api/marchandiseImputee?idMarchandise=${payload.id}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const registerMFAApi = (payload) => {
  return authInstance
    .post(`/registerMFA`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw new Error(e.toString());
    });
};

export const sendOtpMailApi = (payload) => {
  return authInstance
    .post(`/sendOtpMail`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw new Error(e.toString());
    });
};

export const getHistoriqueApi = (payload) => {
  return dfdInstance
    .get(`api/historique?dfdid=${payload.id}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const downloadDemandApi = (payload) => {
  return dfdInstance
    .post(
      `/api/demandes/print?idDemande=${payload.id}`,
      {},
      {
        responseType: "blob",
        headers: {},
      }
    )
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Demande_DFD_${payload.nom}.pdf`);
      document.body.appendChild(link);
      link.click();
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const downloadDemandDocumentApi = (payload) => {
  return dfdInstance
    .get(`/documents/document/${payload.id}`)
    .then((response) => {
      if (payload.action === "SHOW") {
        return response;
      } else if (payload.action === "DOWNLOAD") {
        const url = `data:application/pdf;base64,${response.data}`;
        const fileName = payload.nom;
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();
        return null;
      }
    })
    .catch((e) => {
      throw e;
    });
};

export const getDecisionTypeApi = (payload) => {
  return dfdInstance
    .get(`/decisionType/`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getUniteDouniereApi = (payload) => {
  return dfdInstance
    .get(`/api/uniteDouniere/`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getUniteCompApi = (payload) => {
  return dfdInstance
    .get(`/api/unitQuantity/`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getDepartmentsApi = () => {
  return dfdInstance
    .get(`/api/departement`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const DecisionMceDfdApi = (payload) => {
  const startDateParts = payload.startDate.split("/");
  const endDateParts = payload.endDate.split("/");
  const startDate = `${startDateParts[2]}-${startDateParts[1]}-${startDateParts[0]}`;
  const endDate = `${endDateParts[2]}-${endDateParts[1]}-${endDateParts[0]}`;

  return dfdInstance
    .post(
      `/api/demandes/decision?isDecision=true&endDate=${endDate}&startDate=${startDate}`,
      payload.payload
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const DecisionDepDfdApi = (payload) => {
  return dfdInstance
    .post(`/api/demandes/decisionDepartement`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const transferDfdApi = (payload) => {
  return dfdInstance
    .post(`/api/demandes/transferer`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getNomenclaturesGroupeApi = (payload) => {
  return dfdInstance
    .get(`api/categorieofNomenclature?code=${payload.payload}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getSelectedDepartmentsApi = (payload) => {
  return dfdInstance
    .get(`api/demandes/findDepartementByNum?numero=${payload.id}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getFixedDfdDecisionApi = (payload) => {
  return dfdInstance
    .get(`api/demandes/getTypeDecision?dfdId=${payload.id}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const AuthentificationApi = (payload) => {
  return authInstance
    .post(`/signIn`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw new Error(e.toString());
    });
};

export const postDFDColumnsDensityStateApi = (payload) => {
  return dfdInstance
    .post(`/api/etatTableDFD/`, payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getDFDColumnsDensityStateApi = () => {
  return dfdInstance
    .get(`/api/etatTableDFD/`, {
      params: {
        projectName: "de l'importateur/",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const postChangePasswordApi = (payload) => {
  return crcInstance
    .put(`/api/user/changePassword`, payload.payload)
    .then((response) => {
      return { success: true, data: response.data };
    })
    .catch((error) => {
      return {
        success: false,
        error: error.response
          ? error.response.data
          : "An unknown error occurred",
      };
    });
};

export const fetchKpiDfdApi = (payload) => {
  return dfdInstance
    .get(`api/demandes/kpi?year=${payload.year}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const updateDfdDateFinValiditeApi = (payload) => {
  let idDFD = payload?.payload?.idDFD;
  const dateFinValiditeParts = payload?.payload.dateFinValidite.split("/");
  const dateFinValidite = `${dateFinValiditeParts[2]}-${dateFinValiditeParts[1]}-${dateFinValiditeParts[0]}`;

  return dfdInstance
    .post(
      `/api/demandes/change-date-validite?idDFD=${idDFD}&dateFinValidite=${dateFinValidite}`
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const checkForfaitApi = (token) => {
  return forfaitInstance
    .get(`/api/portails/situation`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response)
    .catch((e) => {
      throw new Error(e.toString());
    });
};
